import isGHMC, { getCurrentDate, getCurrentDateTime, getFirstDateOfMonth } from "../../../../Common/helper/helpar";
import { Formik, Form, Field } from "formik";
import { useMonthWiseAttendanceStore } from "./MonthWiseAttendanceStore";
import { useEffect, useState } from "react";
import { GetCircle, GetZone } from "../../../../Apis/organizationApi";
import { GetOperations, GetDesignations } from "../../../../Apis/operationApi";
import { MonthWiseAttendanceExport } from "./MonthWiseAttendanceExport";
import { getAllTransferStationMaster } from "../../../../Apis/transferStationApi";
import { getOneMonthPastDate, getTodayDate } from "../../../AssetVehicle/utils/helpers";

export const MonthWiseAttendanceFilters = () => {
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [allTransferStation, setAllTransferStation] = useState([]);
  const [allOperations, setAllOperations] = useState([]);
  const [allDesignation, setallDesignation] = useState([]);
  const [days, setDays] = useState([]);
  const isProd = isGHMC();
  const currentDate = getCurrentDate();
  const { MonthWiseAttendanceData, fetchMonthWiseAttendanceReport } =
    useMonthWiseAttendanceStore();
  const today = new Date();
  const fetchAllDataDetails = async () => {
    try {
      const transferStationData = await getAllTransferStationMaster()
      setAllTransferStation(transferStationData);
      const zonesData = await GetZone();
      setAllZones(zonesData);
      const circlesData = await GetCircle();
      setAllCircles(circlesData);
      const operationsData = await GetOperations();
      console.log("Fetched Operations Data:", operationsData); // Debugging step
      setAllOperations(Array.isArray(operationsData) ? operationsData : []);
      const designationsData = await GetDesignations();
      setallDesignation(
        Array.isArray(designationsData) ? designationsData : []
      );
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };
  useEffect(() => {
    if (MonthWiseAttendanceData[0]?.dayWiseAttendance) {
      const getMonth = JSON?.parse(
        MonthWiseAttendanceData[0]?.dayWiseAttendance
      );
      setDays(getMonth);
    } else {
      setDays([]);
    }
  }, [MonthWiseAttendanceData, MonthWiseAttendanceData[0]?.dayWiseAttendance]);

  const getLast30DaysDate = (day) => {
    const toDate = new Date(day);
    const thirtyDaysAgo = new Date(toDate.setDate(toDate.getDate() - 30));
    return thirtyDaysAgo.toISOString().split("T")[0]; // Format the date as YYYY-MM-DD
  };

  const initialFilterValues = {
    FromDate: getFirstDateOfMonth(),
    ToDate: currentDate,
    ZoneId: "",
    CircleId: "",
    EmployeeId: "",
    DesignationId: "",
    OperationId: "",
    EmployeeName: "",
  };

  const handleSubmit = (values) => {
    fetchMonthWiseAttendanceReport(values);
  };

  useEffect(() => {
    fetchAllDataDetails();
    fetchMonthWiseAttendanceReport(initialFilterValues);
  }, []);

  const handleReset = (resetForm) => {
    resetForm();
    fetchMonthWiseAttendanceReport(initialFilterValues);
  };

  return (
    <>
      <Formik initialValues={initialFilterValues} onSubmit={handleSubmit}>
        {({ values, setFieldValue, resetForm }) => (
          <Form>
            <div className=" row d-flex align-items-center">
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label w-100 text-left">
                    From Date
                  </label>
                  <Field
                    type="date"
                    id="FromDate"
                    value={values.FromDate}
                    name="FromDate"
                    className="form-control"
  min={getOneMonthPastDate()}
  max={getTodayDate()}
                    required
                  />
                </div>
              </div>
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label w-100 text-left">To Date</label>
                  <Field
                    type="date"
                    id="ToDate"
                    name="ToDate"
                    value={values.ToDate}
                    className="form-control"
                    max={currentDate}
                    required
                  />
                </div>
              </div>
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {/* {t("vehicleZone")} */}
                    Zone
                  </label>
                  <Field
                    as="select"
                    id="ZoneId"
                    name="ZoneId"
                    value={values.ZoneId}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {allZones
                      ?.filter((zone) => zone.isActive)
                      .map((zone) => (
                        <option key={zone.zoneId} value={zone.zoneId}>
                          {zone.zoneName}
                        </option>
                      ))}
                  </Field>
                </div>
              </div>
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {/* {t("vehicleCircle")}{" "} */}
                    Circle
                  </label>
                  <Field
                    as="select"
                    className={`form-select`}
                    name="CircleId"
                    id="CircleId"
                    value={values.CircleId}
                  >
                    <option value="">Select</option>
                    {allCircles
                      .filter(
                        (circle) =>
                          circle.isActive && circle.zoneId == values.ZoneId
                      )
                      .map((circle) => (
                        <option key={circle.circleId} value={circle.circleId}>
                          {circle.circleName.split(" [")[0]}
                        </option>
                      ))}
                  </Field>
                </div>
              </div>
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label">Employee ID</label>
                  <Field
                    type="text"
                    className="form-control"
                    name="EmployeeId"
                    id="EmployeeId"
                    placeholder="Enter Employee ID"
                  />
                </div>
              </div>
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label">Name</label>
                  <Field
                    type="text"
                    className="form-control"
                    name="EmployeeName"
                    id="EmployeeName"
                    placeholder="Name"
                  />
                </div>
              </div>
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {/* {t("vehicleCircle")}{" "} */}
                    Operation
                  </label>
                  <Field
                    as="select"
                    className={`form-select`}
                    name="OperationId"
                    id="OperationId"
                    value={values.OperationId}
                  >
                    <option value="">Select</option>
                    {allOperations.length > 0 &&
                      allOperations
                        .filter((operation) => operation.isActive) // No need to check `operationId` here
                        .map((operation) => (
                          <option
                            key={operation.operationId}
                            value={operation.operationId}
                          >
                            {operation.operationName.split(" [")[0]}
                          </option>
                        ))}
                  </Field>
                </div>
              </div>
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {/* {t("vehicleCircle")}{" "} */}
                    Designation
                  </label>
                  <Field
                    as="select"
                    className={`form-select`}
                    name="DesignationId"
                    id="DesignationId"
                    value={values.DesignationId}
                    disabled={!values.OperationId} // Disable if no operation is selected
                  >
                    <option value="">Select</option>
                    {allDesignation.length > 0 &&
                      allDesignation
                        .filter(
                          (designation) =>
                            designation.isActive &&
                            designation.operationId == values.OperationId // Filter based on selected operation
                        )
                        .map((designation) => (
                          <option
                            key={designation.designationId}
                            value={designation.designationId}
                          >
                            {designation.designationName}
                          </option>
                        ))}
                  </Field>
                </div>
              </div>
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {/* {t("vehicleCircle")}{" "} */}
                    Transfer Station
                  </label>
                  <Field
                    as="select"
                    className={`form-select`}
                    name="TransferStationId"
                    id="TransferStationId"
                    value={values.TransferStationId}
                  >
                    <option value="">Select</option>
                    {allTransferStation.length > 0 &&
                      allTransferStation
                        .filter(
                          (transferStation) =>
                            transferStation.isActive
                        )
                        .map((transferStation) => (
                          <option
                            key={transferStation.transferStationId}
                            value={transferStation.transferStationId}
                          >
                            {transferStation.transferStationName}
                          </option>
                        ))}
                  </Field>
                </div>
              </div>
              <div className="col-md-3 d-flex gap-2 align-items-end ">
                <button
                  type="submit"
                  className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                >
                  Search
                </button>
                <button
                  type="reset"
                  className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                  onClick={() => handleReset(resetForm)}
                >
                  Reset
                </button>
                <MonthWiseAttendanceExport
                  data={MonthWiseAttendanceData}
                  days={days}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
